export const API_URL = 'https://backend.ramadan.sheehanrahman.com/api/'

export const RAMADAN_TIMES_API = API_URL + 'timeTables/'

export const LOCATIONS_API = 'https://backend.manchitro.club/api/locations/'
export const DIVISIONS_API = LOCATIONS_API + 'divisions/'
export const DISTRICTS_API = LOCATIONS_API + 'districts/'

